module.exports = __webpack_public_path__ + "img/electriconn.ea69cd36.png";